<script>
    import { computed } from 'vue'
    import { useRoute } from 'vue-router'
    import { collapsed } from './state'

    export default {
        props: {
            to: { type: String, required: true },
            icon: { type: String, required: true },
            word: {type:String, required: true},
            
        },
        setup(props) {
            const route = useRoute()
            const isActive = computed(() => {
                const path = route.path
                if (path === props.to) return true
                if (path.includes('Template') && path.includes('Contract')) return false
                if ((path.includes('EditProject') || path.includes('Project')) && props.to === '/MyProjects') return true
                if ((path.includes('InnerBlog') ) && props.to === '/InnerBlog') return true
                return false
            })
            return { isActive, collapsed }
        },
        
    }
</script>

<template>
    <router-link :to="to" class="link" :class="{ active: isActive }">
        
        <i class="icon" :class="icon" v-if="word!='blog'">
            {{word}}
            
        </i>
        <i class="icon" :class="icon" v-else>
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" style="margin-bottom: 5px;">
                <path d="M12.5 10H10c-.55 0-1-.45-1-1s.45-1 1-1h2.5c.55 0 1 .45 1 1s-.45 1-1 1m2.5 4c0-.55-.45-1-1-1h-4c-.55 0-1 .45-1 1s.45 1 1 1h4c.55 0 1-.45 1-1m7-10v16c0 1.11-.89 2-2 2H4c-1.11 0-2-.89-2-2V4c0-1.11.89-2 2-2h16c1.11 0 2 .89 2 2m-4 8s0-1-1-1c-.95.03-1-1-1-1V8c0-1.66-1.34-3-3-3H9C7.34 5 6 6.34 6 8v7c0 1.66 1.34 3 3 3h6c1.66 0 3-1.34 3-3v-3z" fill="currentColor"/>
            </svg>
        </i>
        <transition name="fade">
            <span v-if="!collapsed">
                <slot />
            </span>
        </transition>
    </router-link>
</template>

<style scoped>
    .new-blog{
        color: red;
    }
    .fade-enter-active,
    .fade-leave-active {
        transition: opacity 0.1s;
    }

    .fade-enter,
    .fade-leave-to {
        opacity: 0;
    }

    .link {
        display: flex;
        align-items: center;
        cursor: pointer;
        position: relative;
        font-weight: 400;
        user-select: none;
        margin: 0.1em 0;
        border-radius: 0.25em;
        height: 46px;
        color: white;
        text-decoration: none;
        font-size:12px;
    }

    .link i{color:white;}

        .link:hover {
            background-color: var(--sidebar-item-hover);
        }

        .link.active {
            background-color: var(--sidebar-item-active);
            color: #c3e353;
            border-right: 5px solid #c3e353;
 
        }
        .link.active i {
            background-color: var(--sidebar-item-active);
            color: #c3e353;
         
        }
       

        .link .icon {
            flex-shrink: 0;
            width: 25px;
            margin-right: 10px;
        }
</style>
